import Vue from 'vue'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css';
import App from './App'
import router from './router'
import store from './store/store'
import $ from 'jquery'
import VueLazyload from 'vue-lazyload'
import ElementUI from 'element-ui'
import MetaInfo from 'vue-meta-info'
import 'element-ui/lib/theme-chalk/index.css'
import 'common/stylus/index.styl'
import VeLine from 'v-charts/lib/line.common'
import VePie from 'v-charts/lib/pie.common'
import EventBusClass from "./libs/eventBus"
import {getBuryingPoint} from 'api/classification'
import { getRequest, postRequest, putRequest, deleteRequest, importRequest, uploadFileRequest,postJsonRequest } from '@/libs/axios'
// import VueHighlightJS from 'vue-highlight.js'
// import 'highlight.js/styles/atom-one-dark.css'
// import Hljs from 'highlight.js';
// import 'highlight.js/styles/tomorrow-night.css'; 
// Vue.use(VueHighlightJS)
// require("es6-promise").polyfill()
// import Promise from 'es6-promise'
// Promise.polyfill()
Vue.prototype.postJsonRequest = postJsonRequest;
Vue.prototype.getRequest = getRequest;
Vue.prototype.postRequest = postRequest;
Vue.prototype.putRequest = putRequest;
Vue.prototype.deleteRequest = deleteRequest;
Vue.prototype.importRequest = importRequest;
Vue.prototype.uploadFileRequest = uploadFileRequest;

// 将EventBus放到vue


import Highlight from './utils/highlight'; // from 路径是highlight.js的路径，纯属自定义
Vue.use(Highlight);
Vue.use(ElementUI)
Vue.use(VueLazyload)
Vue.use(MetaInfo)
Vue.use(ViewUI);
Vue.prototype.API_ROOT_UPLOAD = 'https://vex.bqj.cn/'; //正式环境
//Vue.prototype.API_ROOT_UPLOAD = 'https://tsvc.bqj.cn/'; //测试环境
//Vue.prototype.API_ROOT_UPLOAD = 'http://127.0.0.1:18888/'; //开发环境
Vue.prototype.$ = $
Vue.config.productionTip = false
window.toast = function  (str,callbacks) {
  console.log('获取的回调函数的上下文',callbacks)
  var m = document.createElement('div');
  m.innerHTML = str;
  m.style.cssText="padding:0 30px;font-size:16px; min-width:150px; background:#000; opacity:0.77; height:90px; color:#fff; line-height:90px; text-align:center; border-radius:10px; position:fixed; top:45%; left:45%; z-index:99999999;margin-left:-40px;";
   document.body.appendChild(m);
  setTimeout(function() {
     var d = 0.5;
       m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
       m.style.opacity = '0';
     setTimeout(function() { document.body.removeChild(m); if(callbacks){callbacks()}}, d * 1000);
  }, 2000);
}

Vue.component(VeLine.name, VeLine)
Vue.component(VePie.name, VePie)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})
router.beforeEach((to, from, next)=>{
  // 路由守卫，监听全局路由变化，每进入下一个页面之前，发送本页面的统计数据，不过从首页进入其他页面的时候beforEach会执行两次，这个问题尚未解决
  // console.group('页面离开输出')
  // console.log("to", to)
  // console.log("from", from)
  // console.log("next", next)
  // console.log("times:",Date.parse(new Date()))
  // console.groupEnd()
  // if(from.path == '/'){
  //   next({path:to.fullPath})
  //   // next()
  // }else{
    next()
  // }

})
router.afterEach((to, from, next) => {
  // console.group('路由守卫')
  // console.log("to", to)
  // console.log("from", from)
  // console.groupEnd()
  window.scrollTo(0, 0)

})



// WEBPACK FOOTER //
// ./src/main.js